<div class="bg-white w-full flex flex-col gap-2 items-center justify-center h-60 py-2">
  <img
    class="inline-block min-w-[5rem] w-20 h-20 object-cover object-center"
    src="assets/images/empty-data.svg"
    [alt]="'common.no-data' | translate" />
  @if (isSearching && emptyMessage) {
    <span class="text-gray-400 !font-medium">{{
      !keyword ? (emptyMessage | translate) : (emptyMessage | translate: { keyword: keyword })
    }}</span>
  } @else {
    <span class="text-gray-400 !font-medium">
      {{ 'common.no-data' | translate }}
    </span>
  }
</div>
